import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { PagePropsContext } from '../App';
import Search from './Search';
import Breadcrumb from './Breadcrumb';
import { getTextLink } from '../utils/functions';

const Header = ({
  title,
  showBreadcrumb,
  showSearch,
  onBack,
}) => {
  const { t } = useTranslation();
  const { categories, setSelectedCategory, setSelectedQuestion, setShowContact } = useContext(PagePropsContext);

  const handleSelect = (question) => {
    const category = categories.find(c => c.id === question.category);
    category && setSelectedCategory(categories.find(c => c.id === category.parent_category));
    category && setSelectedQuestion(question);
  }

  return <div className='header'>
    <div className='header__content'>
      {onBack && <button className='button button--back' onClick={onBack}></button>}
      <h2 className='header__title'>{title}</h2>
      {showBreadcrumb && <div className='header__breadcrumb'><Breadcrumb /></div>}
      <div className='header__info'>
        <button className='button button--primary' onClick={() => setShowContact(true)}>{getTextLink(t('help.info'))}</button>
      </div>
    </div>
    {showSearch && <div className='header__search'><Search onSelect={handleSelect} /></div>}
  </div>;
}

export default Header;
